export class Breed {
    name: string;
    id: number;
    code: string;
}